import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  timeout: 20000,
});

export function formatApiError(detail) {
  if (detail == null) return null;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function humanizeAxiosError(e) {
  const status = e?.response?.status;
  const data = e?.response?.data;
  // Detect Cloudflare/edge error responses so we NEVER show a raw English
  // "The origin web server sent a response Cloudflare could not parse..." to
  // the end user. Cloudflare returns JSON with type=cloudflare URL and
  // error_category='origin' when Accept: application/json is set.
  const isEdgeError = (typeof data === "object" && data && (
    (typeof data.type === "string" && data.type.includes("cloudflare.com")) ||
    typeof data.error_code === "number" ||
    typeof data.error_name === "string"
  )) || (typeof data === "string" && /cloudflare|cf-error|<!DOCTYPE html/i.test(data));
  if (status >= 500 || isEdgeError) {
    return "Sunucuya şu anda ulaşılamıyor. Lütfen birkaç dakika sonra tekrar deneyin.";
  }
  const detailMsg = formatApiError(data?.detail);
  if (detailMsg) return detailMsg;
  if (status === 401) return "E-posta/telefon veya şifre hatalı";
  if (status === 403) return "Bu işlem için yetkiniz yok";
  if (status === 404) return "Kayıt bulunamadı";
  if (status === 429) return "Çok fazla istek. Lütfen bir süre sonra tekrar deneyin.";
  if (e?.code === "ERR_NETWORK" || e?.message === "Network Error") return "Sunucuya bağlanılamadı. İnternet bağlantınızı kontrol edin.";
  if (e?.code === "ECONNABORTED") return "İstek zaman aşımına uğradı, tekrar deneyin";
  return e?.message || "Bir hata oluştu";
}

export default api;
